(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sp-demo-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sp-demo-reviews')) {
  customElements.define('sp-demo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const button = this.querySelector('.sp-demo__more');
      if (!button) return;
      this.initialized = true;
      button.addEventListener('click', () => {
        const cards = Array.from(this.querySelectorAll('.sp-demo__card'));
        const next = cards.filter(card => card.hidden).slice(0, 15);
        next.forEach(card => { card.hidden = false; });
        const shown = cards.filter(card => !card.hidden).length;
        const status = this.querySelector('.sp-demo__progress');
        status.textContent = status.dataset.progress.replace('__shown__', String(shown));
        button.hidden = shown === cards.length;
        if (next.length) next[0].focus({ preventScroll: true });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
